/**
 * The "?" info tips: one fixed-position bubble per shadow root (fixed, so
 * the results table's overflow can't clip it), shown on hover and focus.
 * Hidden from assistive technology while empty or faded out, and named as
 * the description of the "?" it's showing for while visible.
 */
export function attachTooltips(root: ShadowRoot): void {
  const bubble = document.createElement('div');
  bubble.className = 'tip-bubble';
  bubble.id = 'tip-bubble';
  bubble.setAttribute('role', 'tooltip');
  bubble.setAttribute('aria-hidden', 'true');
  root.appendChild(bubble);
  let shownFor: HTMLElement | null = null;
  function show(el: HTMLElement) {
    const text = el.dataset.tip;
    if (!text) return;
    bubble.textContent = text;
    bubble.classList.add('visible');
    bubble.removeAttribute('aria-hidden');
    shownFor?.removeAttribute('aria-describedby');
    el.setAttribute('aria-describedby', bubble.id);
    shownFor = el;
    const rect = el.getBoundingClientRect();
    const bubbleRect = bubble.getBoundingClientRect();
    let left = rect.left + rect.width / 2 - bubbleRect.width / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - bubbleRect.width - 8));
    let top = rect.top - bubbleRect.height - 8;
    if (top < 8) top = rect.bottom + 8;
    bubble.style.left = `${left}px`;
    bubble.style.top = `${top}px`;
  }
  const hide = () => {
    bubble.classList.remove('visible');
    bubble.setAttribute('aria-hidden', 'true');
    shownFor?.removeAttribute('aria-describedby');
    shownFor = null;
  };
  const tipOf = (e: Event) => (e.target as Element | null)?.closest?.('.info-tip') as HTMLElement | null;
  root.addEventListener('mouseover', (e) => { const t = tipOf(e); if (t) show(t); });
  root.addEventListener('mouseout', (e) => { if (tipOf(e)) hide(); });
  root.addEventListener('focusin', (e) => { const t = tipOf(e); if (t) show(t); });
  root.addEventListener('focusout', (e) => { if (tipOf(e)) hide(); });
}
